
import {
  Container
} from "@mui/material";
import React, { useContext } from "react";

import { ExploreContext } from "../context/explore";
import { isBrowser } from "../helpers/common";
import { ErrorMessage } from "./error-message";
import { ExploreDistributionPlot } from "./explore-plot-distribution";
import { ExploreHistogramPlot } from "./explore-plot-histogram";
import { ExploreRosePlot } from "./explore-plot-roseplot";
import { ExploreTimeseriesPlot } from "./explore-plot-timeseries";
import Loader from "./loader";

export const timeSeriesColunmTitle = "Date/Time"

export interface ConvertedData { 
  [key: string]: (number | string | null)[]
}

export type PlotType = "timeseries" | "rose" | "histogram" | "statistics" | "distribution";

interface ExplorePlotProps {
  type: PlotType | null;
}

export const ExplorePlot = ({
  type,
}: ExplorePlotProps) => {

  const { 
    exploreError,
    loading,
    exploreDataSchema,
  } = useContext(ExploreContext);

  if (!isBrowser()) {
    return null
  }
  
  const dataReady = !(exploreDataSchema === null)

  return (
    <Container maxWidth={false} sx={{ mt: "16px", mb: 0, position: "relative" }}>
      <ErrorMessage message={exploreError} merge />
      <>
        {!dataReady && exploreError.length === 0 && <div style={{ width: "100%", padding: "280px 0 64px 0" }}>
          <Loader center showCog />
        </div>}
        {dataReady && type === 'rose' && 
          <ExploreRosePlot loading={loading}  />
        }
        {dataReady && type === 'timeseries' && 
          <ExploreTimeseriesPlot />
        }
        {/* {dataReady && type === "distribution" && 
          <ExploreDistributionPlot loading={loading} exploreDataSchema={exploreDataSchema} />
        } */}
        {dataReady && type === "distribution" && 
          <ExploreDistributionPlot loading={loading} exploreDataSchema={exploreDataSchema} />
        }
        {dataReady && type === 'histogram' && 
          <ExploreHistogramPlot 
            loading={loading}
            exploreDataSchema={exploreDataSchema}
          />
        }
      </>
    </Container>
  );
};